<template>
  <div class="admin-clone">
    <div class="admin__breadcrumbs">
      <div class="admin__breadcrumb">
        <div class="note">Admin</div>
      </div>
      <div class="admin__breadcrumb">
        <div class="note">></div>
        <div class="note">
          <router-link :to="{ name: 'admin-dashboard', query: {} }">Workflows</router-link>
        </div>
      </div>
      <div class="admin__breadcrumb">
        <div class="note">></div>
        <div class="note">Add Workflow</div>
      </div>
    </div>
    <h1>Add Global Workflow</h1>
    <vue-form-generator
      :schema="buildSchema('workflow', 'workflowSchema', 'basicInfo', 'new')"
      :model="workflow"
      :options="formOptions" />
  </div>
</template>

<script>
import newForm from '@/mixins/new-form';

export default {
  name: 'admin-new-global-workflow',
  mixins: [newForm],

  data() {
    return {
      workflow: {
        colour: '#cc0000',
      },
      formName: 'GlobalWorkflow',
      formIndex: 'admin-dashboard',
    };
  },
};
</script>
